import React from "react"
import PropTypes from "prop-types"
import { Form, TimePicker, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import styles from "../index.module.css"

/**
 * Time range picker component for start and end times
 * Only shown when "Part of Day" is checked
 */
const TimeRangeFields = ({ isPartOfDay }) => {
  const { t } = useTranslation()

  if (!isPartOfDay) return null

  return (
    <Flex gap={16} className="mb-xs">
      <Flex vertical className={styles.fieldWrapper}>
        <Form.Item
          name="startTime"
          label={<Text className={styles.fieldLabel}>{t("crewMember.scheduledTimeOff.fields.startTime")}</Text>}
          required={false}
          rules={[{ required: isPartOfDay, message: t("crewMember.scheduledTimeOff.validation.startTimeRequired") }]}
        >
          <TimePicker
            className={styles.timePicker}
            use12Hours
            format="hh:mm A"
            placeholder={t("crewMember.scheduledTimeOff.placeholders.startTime")}
            needConfirm={false}
          />
        </Form.Item>
      </Flex>

      <Flex align="center" className="pt-s">
        <Text fw="700">—</Text>
      </Flex>

      <Flex vertical className={styles.fieldWrapper}>
        <Form.Item
          name="endTime"
          label={<Text className={styles.fieldLabel}>{t("crewMember.scheduledTimeOff.fields.endTime")}</Text>}
          required={false}
          rules={[{ required: isPartOfDay, message: t("crewMember.scheduledTimeOff.validation.endTimeRequired") }]}
        >
          <TimePicker
            className={styles.timePicker}
            use12Hours
            format="hh:mm A"
            placeholder={t("crewMember.scheduledTimeOff.placeholders.endTime")}
            needConfirm={false}
          />
        </Form.Item>
      </Flex>
    </Flex>
  )
}

TimeRangeFields.propTypes = {
  isPartOfDay: PropTypes.bool.isRequired
}

export default TimeRangeFields
